export interface ILanguage {
  code: string
  label: string
}

export const LANGUAGES: ILanguage[] = [
  { code: 'id', label: 'Bahasa Indonesia (Indonesian)' },
  { code: 'en', label: 'English (English)' },
]

const locales = LANGUAGES.map((lang) => lang.code)

export const LANGUAGE_DICTIONARY: Record<string, ILanguage> = {}

export async function loadLanguages() {
  for (const locale of locales) {
    LANGUAGE_DICTIONARY[locale] = (await import(`../locales/${locale}.json`)).default
  }
}
